import {
  getAsync,
  postAsync,
  putAsync,
  deleteAsync
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/federation";

// Get all federations
export async function getAllFederationsAsync() {
  return await getAsync(`${endpoint}/GetAllFederations`);
}

// Get a federation by its id
export async function getFederationByIdAsync(federationId) {
  return await getAsync(`${endpoint}/${federationId}`);
}

//Get all users in federation
export async function getFederationUsersAsync(federationId) {
  return await getAsync(`${endpoint}/GetFederationUsers/${federationId}`);
}

// Get all users not in federation
export async function getUsersNotInFederationAsync(federationId) {
  return await getAsync(`${endpoint}/GetUsersNotInFederation/${federationId}`);
}

// Get if a user is part of federation
export async function getIsUserPartOfFederationAsync(userId, federationId){
  return await getAsync(`${endpoint}/GetIsUserPartOfFederation/${userId}/${federationId}`);
}

// Get all users' federations
export async function getAllCurrentUserFederationsAsync() {
  return await getAsync(`${endpoint}/GetAllCurrentUserFederations`);
}

// Affect a list of users to a federation
export async function affectUsersToFederationAsync(federationId, usersIds) {
  return await postAsync(`${endpoint}/AffectUsersToFederation/${federationId}`, usersIds);
}

// Remove a user from a federation
export async function removeUserFromFederationAsync(FederationId, userId) {
  return await deleteAsync(`${endpoint}/RemoveUserFromFederation/${FederationId}/${userId}`);
}

// POST affect a category to discipline
export async function affectCategoryToDiscipline(cat) {
  return await postAsync(`${endpoint}/AffectCategoryToDiscipline`, cat);
}

// CREATE a federation
export async function createFederationAsync(model) {
  return await postAsync(`${endpoint}`, model);
}

// UPDATE a federation
export async function updateFederationAsync(federationId, model) {
  return await putAsync(`${endpoint}/${federationId}`, model);
}

// DELETE a federation
export async function deleteFederationAsync(FederationId) {
  return await deleteAsync(`${endpoint}/${FederationId}`);
}